import { staticGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createSampledSegment = {
  name: "createSampledSegment" as const,
  input: z.object({
    customerGroupId: zExt.objectId(),
    sampleSize: z.number().min(1).default(1000),
    name: z.string(),
  }),
  output: staticGroupSchema,
};
